module.exports = __webpack_public_path__ + "static/media/PlacementSelection.c2a369b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/ThreeHundred/PlacementSelection.jpg
// module id = 829
// module chunks = 5